import React from "react";
import { cn } from "@/lib";

interface Props {
  className?: string;
  children: React.ReactNode;
}

const Wrapper = ({ children, className }: Props) => {
  return (
    <div
      className={cn(
        "w-full mx-auto px-4 sm:px-6 md:px-8 lg:px-12 lg:max-w-screen-xl overflow-x-hidden lg:overflow-visible",
        className,
      )}
      data-oid="s_zknhx"
    >
      {children}
    </div>
  );
};

export default Wrapper;
